<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      limitationsList: [],
      limitations: [],
      disableNext: false,
      excludedBrand: null,
    };
  },
  async created() {
    await this.getStoreLimitiation();
    await this.checkLimitations(this.$store.state.eCommerce.cartItems.slice().reverse());
    await this.getExcludedBrand();
  },
  computed: {
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },
  },
  methods: {
    ...mapActions('storeProducts', ['fetchStoreLimitation']),
    ...mapActions('ecommerce', ['getCartItemsFromApi']),
    ...mapActions('admin', ['getSettingsByKey']),
    shouldDisableNext(condition, limitation) {
      if (condition && condition === 'and') {
        return (limitation.isAboveMax || limitation.isBelowMin) && limitation.isBelowAmount;
      }
      return limitation.isAboveMax || limitation.isBelowMin || limitation.isBelowAmount;
    },
    checkLimitations(itemsInCart) {
      this.disableNext = false;
      const currentClincid = sessionStorage.getItem('doctorClinicSelectedClinic');
      const limitations = _.pullAll(_.cloneDeep(this.limitations).map(limitation => {
        const condition = limitation.condition ? limitation.condition : null;
        const productIds = limitation.products.map(item => (item.productId));
        const clinicsIds = limitation.clinics.map(item => (item.clinicId));
        const productsWithinLimit = _.pullAll(itemsInCart.map(product => {
          if (_.indexOf(productIds, product.productStoreId) >= 0) {
            return product;
          }
          return undefined;
        }), [undefined]);
        const totalAmountFromSameSupplier = _.sum(itemsInCart.map(product=>{
          if(productsWithinLimit.length > 0 && productsWithinLimit[0].inventory.managedBy === product.inventory.managedBy ){
            return (product.price / 100) * product.quantity;
          }
          return 0;
        }));
        const isForcurrentClinic = clinicsIds.length > 0 ? _.indexOf(clinicsIds, currentClincid) >= 0 : true;
        if (isForcurrentClinic && productsWithinLimit.length > 0) {
          const totalQuantityInLimit = _.sum(productsWithinLimit.map(product => (product.quantity)));
          limitation.isAboveMax = (!limitation.max_qty || limitation.max_qty === 0) ? false : totalQuantityInLimit > limitation.max_qty;
          limitation.isBelowMin = totalQuantityInLimit < limitation.min_qty;
          limitation.isBelowAmount = totalAmountFromSameSupplier < limitation.min_purchase_amount;

          // Apply condition from store limitation
          if (this.shouldDisableNext(condition, limitation)) {
            this.disableNext = true;

            return limitation;
          }
          return undefined;
        }
        return undefined;
      }), [undefined]);
      this.limitationsList = limitations
      ;
    },
    async getStoreLimitiation() {
      const { data } = await this.fetchStoreLimitation();
      this.limitations = data.data.docs;
    },
    getCartItems() {
      this.getCartItemsFromApi();
    },
    async getExcludedBrand() {
      try {
        const { data } = await this.getSettingsByKey('excludedBrand');
        this.excludedBrand = data.data.value;
      } catch (error) {
        console.error(error);
      }
    },
    isBrandVisible(brandName) {
      if (this.excludedBrand) {
        return brandName.toLowerCase() === this.excludedBrand.toLowerCase() ? false : true;
      }
    },
  },
  watch: {
    '$store.state.eCommerce.cartItems': function (val) {
      this.checkLimitations(val);
    },
    '$store.state.clinicId': function () {
      this.getCartItems();
    },
  },
};
</script>
